import Alert from "./alert";
import { FormattedDollars } from "./formatted-currency";
import pure from "./higher-order/pure";
import React from "react";
import { Link } from "react-router-dom";

export default pure(function LiveBankrollNotification({ accepted, onToggleAcceptance, session, tournament }) {
  var moneyBuyInAmount = tournament.get("money_buy_in_amount");
  var liveBankrollAmount = tournament.get("bankroll_buy_in_amount");
  var hasAdwAccount = session.get("has_adw_account");

  var action = (
    <p>
      <Link className="link--is-underlined" to="/my-account/adw-account">
        Click here
      </Link>

      {" "}
      to upgrade your account for Live Bankroll ADW contests.
    </p>
  );
  if (hasAdwAccount) {
    action = (
      <p>
        <label className="label--inline" htmlFor="accept-terms" onClick={e => e.stopPropagation()}>
          <input checked={accepted} id="accept-terms" name="accept-terms" onChange={onToggleAcceptance} type="checkbox" />

          {" "}
          Yes, I understand that I will be creating wagers in this Live Bankroll contest, and the wagers will be placed via my Paribet ADW account. The leaderboard will show how much of my live bankroll remains. At the end of the game, any remaining live bankroll funds are added back into my account.
        </label>
      </p>
    );
  }

  var title = (
    <span>
      Live Bankroll Game
      {" "}

      <span className="text--is-italic text--is-normal text-small">
        (Best bankroll based on ADW wagers.)
      </span>
    </span>
  );
  return (
    <Alert icon="dw-warning6" subtle title={title} type="notification--caution">
      <p>
        <span className="text--is-bold">
          My
          <FormattedDollars key="moneyBuyInAmount" value={moneyBuyInAmount} />

          {" "}
          game entry includes a

          <FormattedDollars key="liveBankrollAmount" value={liveBankrollAmount} />

          {" "}
          Live Bankroll
        </span>

        {" "}
        from which I will place real wagers to my ADW account.
      </p>

      {action}
    </Alert>
  );
});
